export class Coursedata {
    id:number;
    bestofFour:any;
    bracketid:any;
    checkcutoff:any;
    coursenm:any;
    coursetp:any;
    selchxbx:any;
    shiftid:any;
    streamid:any;
    svdchxbx:any;
    totalscore:any;
}



// WEBPACK FOOTER //
// ./src/app/data/coursedata.model.ts